import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Translation } from '../../common';

const Welcome = ({ styles, header, content }) => (
  <div className={styles['login-welcome__wrapper']}>
    <Translation
      className={classNames(
        styles['login-welcome__header'],
        styles['login-welcome']
      )}
    >
      LOGINPAGE_HEADER
    </Translation>
    <Translation
      className={classNames(
        styles['login-welcome__content'],
        styles['login-welcome']
      )}
    >
      LOGINPAGE_DESCRIPTION
    </Translation>
  </div>
);

Welcome.propTypes = {
  styles: PropTypes.object,
  header: PropTypes.string,
  content: PropTypes.node
};

export default Welcome;
